import { createRouter, createWebHistory } from 'vue-router'

const WelcomeIndex = () => import('@pages/welcome/Index.vue')
const NewsIndex = () => import('@pages/news/Index.vue')
const ProjectsIndex = () => import('@pages/projects/Index.vue')
const PermissionsIndex = () => import('@pages/permissions/Index.vue')
const DocumentsIndex = () => import('@pages/documents/Index.vue')

const StatisticsIndex = () => import ('@pages/statistics/Index.vue')
const StatisticsShow = () => import ('@pages/statistics/Show.vue')

const ComponentsIndex = () => import('@pages/components/Index.vue')
const ComponentsShow = () => import('@pages/components/Show.vue')

const ManageIndex = () => import('@pages/manage/Index.vue')
const ManageShow = () => import('@pages/manage/Show.vue')
const IndicatorsTab = () => import('@pages/manage/tabs/Indicators.vue')
const ControlPoints = () => import('@pages/manage/tabs/ControlPoints.vue')
const ComponentsTab = () => import('@pages/manage/tabs/Components.vue')


const routes = [
  { path: '/', name: 'welcome.index', component: WelcomeIndex, meta: { title: 'Стартовая страница' } },
  { path: '/news', name: 'news.index', component: NewsIndex, meta: { title: 'Новости' } },
  { path: '/projects', name: 'projects.index', component: ProjectsIndex, meta: { title: 'Проекты' } },
  { path: '/permissions', name: 'permissions.index',component: PermissionsIndex, meta: { title: 'Права доступа' } },
  { path: '/documents', name: 'documents.index', component: DocumentsIndex, meta: { title: 'Документы' } },
  { path: '/statistics', name: 'statistics.index', component: StatisticsIndex, meta: { title: 'Статистика' } },
  { path: '/statistics/:id', name: 'statistics.show', component: StatisticsShow, meta: { title: 'Статистика' } },

  { path: '/components', name: 'components.index', component: ComponentsIndex, meta: { title: 'Компоненты' } },
  { path: '/components/:id', name: 'components.show', component: ComponentsShow, meta: { title: 'Компоненты' } },

  { path: '/manage', name: 'manage.index', component: ManageIndex, meta: { title: 'Управление' } },
  {
    path: '/manage/:id',
    name: 'manage.show',
    component: ManageShow,
    meta: { title: 'Управление' },
    redirect: to => `/manage/${to.params.id}/components`,
    children: [
      { path: 'indicators', name: 'manage.show.indicators', component: IndicatorsTab },
      { path: 'control_points', name: 'manage.show.control_points', component: ControlPoints },
      { path: 'components', name: 'manage.show.components', component: ComponentsTab },
    ]
  },


  { path: '/:pathMatch(.*)*', name: 'not_found', redirect: () => { window.location.href = '/404.html' } },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})


export default router